export default __webpack_public_path__ + "static/media/entrevista.edb9463b.jpeg";